import { Dispatcher } from 'flux'
import { Job } from 'sprockets_react/job_wizards/registries'

Job.Dispatcher = new Dispatcher()
